function fn_comp_article() {
    var $fn = $(".comp_article");

    if ($fn.length) {
        var $gallery = $fn.find(".elm_gallery");

        $gallery.lightGallery({
            selector: ".elm_thumb a"
        });

        $gallery.on('onBeforeOpen.lg',function(event){
            $("body").addClass("no-scroll");
        });


        $gallery.on('onCloseAfter.lg',function(event){
            $("body").removeClass("no-scroll");
        });
    }
}